<div class="header1">
  <div class="header-content">
    <div class="logo-section">
      <i class="fas fa-gem"></i>
      <h1>SoftDiamond</h1>
    </div>

    <div class="user-section">
      <div class="user-info">
        <mat-icon>account_circle</mat-icon>
        <span class="user-details">
          UserName: {{ userName }} - Role: {{ role }}
        </span>
      </div>
      <div class="logout-section">
        <button mat-raised-button 
                class="logout-button"
                (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </div>
</div>